import React from "react";
import { Checkbox } from "redux-form-material-ui";
import { Field } from "redux-form";
import styled from 'styled-components'
import "./styles.css";

// Styles
const BiweeklyAgreementText = styled.p`
  margin-top: 0;
`

const AgreementCheckbox = ({ installmentPayment, totalCost, downPayment }) => (
  <div>
    <Field
      component={Checkbox}
      name="agreementCheckbox"
      // label="I agree to the following:"
      label={`By selecting "Make Down Payment":`}
      labelPosition="right"
      labelStyle={{
        fontFamily: `'Montserrat', sans-serif`,
        fontWeight: "600",
        color: "rgba(0, 0, 0, 0.87)",
        marginBottom: "15px"
      }}
    />
    <div class="agreement">
      <BiweeklyAgreementText>
        I agree I will automatically be charged ${installmentPayment} every 2
        weeks until my total balance of ${totalCost} is paid off.
      </BiweeklyAgreementText>
      <p>
        {/* I agree to this purchase of ${downPayment}. I have read, accept and agree */}
        I agree to today's down payment of ${downPayment}. I have read, accept and
        agree to the airline’s fare rules the{" "}
        <a
          href="http://secure.rezserver.com/flights/help/terms/?refid=8261"
          target="_blank"
        >
          terms and conditions
        </a>{" "}
        and{" "}
        <a
          href="http://secure.rezserver.com/flights/help/privacy/?refid=8261"
          target="_blank"
        >
          privacy policy
        </a>.
      </p>
      {/* <br />
      <br />
      My ${installmentPayment} down payment, due today, is non-refundable. */}
    </div>
  </div>
);

export default AgreementCheckbox;



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/CustomerInfoForm/components/AgreementCheckbox/index.js